export function formatAmount(value, decimals = 2) {
    if (value === null || value === undefined) return ''

    return new Intl.NumberFormat('da-DK', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(Number(value))
}